module.exports = __webpack_public_path__ + "static/media/iaf_logo.504614ed.png";